export default __webpack_public_path__ + "static/media/crude-graph.087ac27b.svg";